
<mat-toolbar class="primary" fxLayoutAlign="space-between center">
    <mat-toolbar-row class=" primary-colorr">
        <div class="container ">
            <div fxLayout="row wrap" fxLayoutAlign="center center">
                <div fxLayout="row" fxLayoutGap="10px">
  
                    <section  class="pointer" (click)="goToHomePage()" >
                        <a>
                            <img class="isa" style="padding: 10px 0px 10px 0px;" fxFlex="80" fxLayoutAlign="center center"  onerror="this.src='assets/images/error/logoerror1.png'; this.style.width='80px';"
                                [src]="serverPath+'logo.png'" alt="error404">
                        </a>
  
                    </section>
                  
                </div>
        
            </div>
        </div>
    </mat-toolbar-row>
  
  </mat-toolbar>

  <div  fxLayout="column" class="content-layout fullwidth-basic-content-scroll">
    <div fxLayout="row" fxLayoutAlign="center center">
        <img class="image"
        src="assets/images/error/404.svg">
    
    </div>
    
    <div fxLayout="row" fxLayoutAlign="center center">
        <h6>Unfortunately the page you are looking for has been moved or deleted</h6>
    </div>
        <div class="padding-10" fxLayout="row" fxFlex fxLayoutAlign="center center">
        <button mat-flat-button  (click)="goToHomePage()" color="primary">  GO TO HOMEPAGE</button>
    </div>
    
    </div>